export const BILLING_INTERVAL = {
	MONTHLY: { key: 'month', message: 'monthly' },
	DAILY: { key: 'day', message: 'daily' },
	ANNUAL: { key: 'year', message: 'annual' },
};

export const PAYMENT_METHOD = {
	RECURRING: { key: 'recurring', message: 'recurrent' },
	PUNTUAL: { key: 'one_time', message: 'punctual' },
};
